import { useMemo } from 'react'

import { useFilters } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import useSelectEntities from '@hooks/useSelectEntities'

import PageContent from './components/PageContent'

const List = () => {
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  // toggling publicationBookingItems to bulk_delete
  const unselectEntitiesPayload = useSelectEntities()
  const {
    callbacks: selectEntitiesCallbacks,
    hasSelectedEntities,
    selectedEntityIds,
  } = unselectEntitiesPayload

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      ...selectEntitiesCallbacks,
    },
    defaultFilters,
    selectedEntityIds,
    hasSelectedEntities,
  }), [selectedEntityIds.length])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent pageFilters={pageFilters} />
    </PageContext.Provider>
  )
}

export default List
